import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { ukDateTime } from "../lib/dates";
import { History } from "lucide-react";

const CARD = "bg-white rounded-2xl border border-[#EBE9E4] shadow-[0_8px_30px_rgba(45,45,45,0.04)]";

export default function CellAudit() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/cell/audit"); setRows(data.audit || []); }
      catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="cell-audit-page">
      <div className="sj-page-hero">
        <h1 className="font-head text-3xl font-semibold flex items-center gap-2" style={{ color: "var(--sj-text)" }}><History className="h-7 w-7" style={{ color: "var(--sj-primary)" }} /> Cell Group — Audit</h1>
        <p className="text-sm mt-1" style={{ color: "var(--sj-text-2)" }}>Who did what in cell-group planning, for accountability.</p>
      </div>
      <div className={`${CARD} overflow-hidden`}>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wider" style={{ color: "var(--sj-text-3)", background: "#F7F7F5" }}>
                <th className="px-4 py-3">When</th><th className="px-4 py-3">User</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Details</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={4} className="px-4 py-8 text-center" style={{ color: "var(--sj-text-3)" }}>Loading…</td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan={4} className="px-4 py-8 text-center" style={{ color: "var(--sj-text-3)" }}>No activity yet.</td></tr>
              ) : rows.map((r) => (
                <tr key={r.id} data-testid={`cell-audit-row-${r.id}`} className="border-t" style={{ borderColor: "var(--sj-border)" }}>
                  <td className="px-4 py-3 whitespace-nowrap" style={{ color: "var(--sj-text-3)" }}>{ukDateTime(r.timestamp)}</td>
                  <td className="px-4 py-3" style={{ color: "var(--sj-text-2)" }}>{r.user}</td>
                  <td className="px-4 py-3"><span className="text-xs font-semibold px-2 py-0.5 rounded-full" style={{ background: "#E3F1EC", color: "#0B5E4E" }}>{(r.action || "").replace(/_/g, " ")}</span></td>
                  <td className="px-4 py-3" style={{ color: "var(--sj-text-2)" }}>{r.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
